// types/user.ts

export interface UserList {
  userID: number;
  firstName: string;
  lastName: string;
  emailID: string;
  allowPOS: boolean;
  fullName: string;
  email: string;
  phone?: string | null;
  userRoleIDs: number[] | null;
  roleName: string;
  posAllowed: boolean;
  isSalesRep?: boolean;
  defaultCommissionPerc?: number | null;
  active: boolean;
  createdOn?: string;
  createdByUserName?: string;
  updatedOn?: string;
  updatedByUserName?: string;
  twoFAEnabled?: boolean;
  userType?: number;
  ppfUserType?: number | string | null;
  userRoleNames?: string;
  updatedOnISO?: string | null;
}

export interface User {
  userID: number;
  fullName: string;
  email?: string;
  mobile?: string;
  role?: string;
  isActive?: boolean;
  profilePic?: string;
}

export interface UserProps {
  modal: boolean;
  handleClose: () => void;
}

export interface UserFilters {
  search?: string;
  roleID?: number;
  isActive?: boolean;
  posAllowed?: boolean;
}

export enum PPFUserType {
  Admin = 1,
  SalesRep = 2,
  PlanReviewer = 4,
  Inspector = 8,
  ProjectSpecialist = 16,
  PrivateProvider = 32
}

export const isPrivateProvider = (value: number | string | null | undefined): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') {
    const trimmed = value.trim().toLowerCase();
    if (trimmed.includes('private provider') || trimmed.includes('privateprovider')) {
      return true;
    }
    const num = Number(trimmed);
    if (!isNaN(num)) {
      return (num & PPFUserType.PrivateProvider) === PPFUserType.PrivateProvider;
    }
    return false;
  }
  return ((value ?? 0) & PPFUserType.PrivateProvider) === PPFUserType.PrivateProvider;
};

export const PPF_USER_TYPE_OPTIONS = [
  { userType: 'Admin', value: PPFUserType.Admin },
  { userType: 'Sales Rep', value: PPFUserType.SalesRep },
  { userType: 'Plan Reviewer', value: PPFUserType.PlanReviewer },
  { userType: 'Inspector', value: PPFUserType.Inspector },
  { userType: 'Project Specialist', value: PPFUserType.ProjectSpecialist },
  { userType: 'Private Provider', value: PPFUserType.PrivateProvider }
];

export interface PermitType {
  municipalityID: number;
  permitTypeID: number;
  permitTypeName: string;
}

export interface Municipality {
  municipalityID: number;
  municipalityName: string;
  countyID: number;
  countyName: string | null;
  stateID: number;
  stateName: string | null;
}

export interface Permit {
  permitTypes: PermitType[];
  municipalities: Municipality[];
}
